import { normalizeAuditPage, normalizeAuditPlants } from '../utils/normalize';

import type { AuditChangeType, AuditFilters, AuditPage, AuditPlantSummary } from '../types/domain.types';

import { USER_CENTER_ENDPOINTS } from './endpoints';
import { request } from './http';
import { auditPageSchema, auditPlantsSchema, parseOrThrow } from './schemas';

/**
 * One page of the trail. The server sets the window and says what it was; the
 * only dates sent are the edges of a window it answered before, sent back as they
 * came, so a plant's list covers exactly the stretch its count was taken over.
 */
export const fetchAudit = async (filters: AuditFilters, signal?: AbortSignal): Promise<AuditPage> => {
  const params: Record<string, unknown> = {};
  if (filters.changeType) params.changeType = filters.changeType;
  if (filters.plantId) params.plantId = filters.plantId;
  if (filters.targetUserId) params.targetUserId = filters.targetUserId;
  if (filters.window) {
    params.from = filters.window.from;
    params.to = filters.window.to;
  }
  if (filters.cursor) params.cursor = filters.cursor;
  if (filters.limit) params.limit = filters.limit;
  const raw = await request('get', USER_CENTER_ENDPOINTS.AUDIT, { params, signal });
  return normalizeAuditPage(parseOrThrow(auditPageSchema, raw, 'audit log'));
};

/** The trail counted by plant, in the server's window. */
export const fetchAuditPlants = async (filters: { readonly changeType?: AuditChangeType }, signal?: AbortSignal): Promise<AuditPlantSummary> => {
  const params: Record<string, unknown> = {};
  if (filters.changeType) params.changeType = filters.changeType;
  const raw = await request('get', USER_CENTER_ENDPOINTS.AUDIT_PLANTS, { params, signal });
  return normalizeAuditPlants(parseOrThrow(auditPlantsSchema, raw, 'audit by plant'));
};
